import { render, staticRenderFns } from "./DepartmentScoreboard.vue?vue&type=template&id=5aeffeec&scoped=true"
import script from "./DepartmentScoreboard.vue?vue&type=script&lang=ts"
export * from "./DepartmentScoreboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aeffeec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
